import React from 'react';
import './WelcomePage.css';
import './AppBackground.css';
import { useNavigate } from 'react-router-dom';
import topborder from '../assets/top_border.svg';
import { useState, useEffect } from 'react';

function WelcomePage() {
  const navigate = useNavigate();
  const [fadeOut, setFadeOut] = useState(false);  // State to handle fade out


  const onStart = () => {
    setFadeOut(true);  // Trigger fade out
    setTimeout(() => {
      navigate('/quiz');  // Navigate after fade out completes
    }, 1000);  // Delay should match the animation duration
  };

  const [bottomBorderHeight, setBottomBorderHeight] = useState('0px');

  useEffect(() => {
    const updateBorderHeight = () => {
      const topBorder = document.querySelector('.top-border-img');
      if (topBorder) {
        setBottomBorderHeight(`${topBorder.offsetHeight}px`);
      }
    };

    // Call once to set initial height
    updateBorderHeight();

    // Add event listener to update height on window resize
    window.addEventListener('resize', updateBorderHeight);

    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener('resize', updateBorderHeight);
    };
  }, []);

  return (
    <div className={`app-background`}>
      <div className={`welcome-container ${fadeOut ? 'fade-out' : ''}`}>
        <img className="top-border-img" src={topborder} alt="top border" />
        <div className="text-container">
          <h1>Who Said It?<br></br><em>A Court of Mist and Fury</em> Edition!</h1>
          <p>Test your knowledge and see how well you know the world and the characters of Prythian. Are you ready to begin?</p>
          <button onClick={onStart}>Start Game</button>
        </div>
        <div className="bottom-border" style={{ height: bottomBorderHeight }}></div>
      </div>
    </div>
  );
}

export default WelcomePage;
